<template>
  <div class="mt-4">
    <loader v-if="loading"></loader>
    <div v-else>
      <div class="title">CLIENTS</div>
      <div class="progress align-middle" style="width:100%;position: relative; top: 40%; height: 4px;">
        <div
          class="progress-bar progress-bar-success"
          role="progressbar"
          v-for="client in clients"
          v-bind:style="{ width: client.percentToTotal + '%', background: client.color }"
        ></div>
      </div>
      <div class="mt-3">
        <div v-for="client in clients" class="mr-4" style="display: inline-block">
          <span class="m-badge m-badge--dot mr-2" :style="{ background: client.color }"></span>
          <strong>{{ client.percentToTotal }}% </strong> {{ client.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Colors from '../../components/colors'

  export default {
    props: [
      'startDate',
      'endDate'
    ],

    data() {
      return {
        clients: [],
        loading: true
      }
    },

    watch: {
      startDate: function() {
        this.onRangeChanged()
      },
      endDate: function() {
        this.onRangeChanged()
      }
    },

    created() {
      this.getClients()
    },

    methods: {
      onRangeChanged() {
        this.loading = true
        this.getClients()
      },

      getClients() {
        const data = {
          startDate: this.startDate,
          endDate: this.endDate
        }

        this.axios.get('reports/overall/clients', { params: data })
          .then(res => {
            this.clients = res.data.data

            const colorsGenerator = new Colors()
            this.clients.forEach(client => client.color = colorsGenerator.getColor())

            this.loading = false
          })
          .catch(error => {})
      },
    },
  }
</script>

<style scoped>
  .title {
    padding-bottom: 15px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/reports/ClientsOverall.vue